
<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" >
      <div class="modal" style="width: 100%; height: 100%;">
        <header class="modal-header">
          <slot name="header">
            <v-btn
              absolute
              dark
              fab
              right
              type="button"
              class="btn-close"
              @click="close"
              color="pink"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </slot>
        </header>

        <div v-show="picSelected && !apngAnimating">
            <v-progress-circular indeterminate size=48 color="white" >
            </v-progress-circular>
            <div class="white--text">
              Please be patient...processing can take a while
            </div>
            <div ref="supergifparent" v-show="false">
            </div>
        </div>
        <div v-show="apngAnimating">
          <div id="animatedpngContainer">
            <div id="animatedpng" ref="animatedpng"></div>
          </div>

          <ImageCrop
            ref="imagecropper"
            v-on:crop="onCropImage"
          />
          <div v-if="!isTalkrFile && apngAnimating">
          <v-layout
            row
            wrap
          >
            <v-flex px-5>
              <v-range-slider v-if="maxFrame > 1"
                thumb-label="always"
                v-on:input="onDragFrames()"
                v-on:start="onStartChangeFrames()"
                v-on:change="onChangeFrames()"
                v-model="frameStartEnd"
                :max="maxFrame"
                :min="0"
                :step="1"
              ></v-range-slider>
            </v-flex>
          </v-layout>

          <v-layout justify-space-between>
            <v-flex xs3>
            <v-checkbox
              v-if="maxFrame > 1"
              v-on:change="onUpdateFrameBounds()"
              :label="`Reverse`"
              v-model="reversed"
              style="max-width: 150px"
            ></v-checkbox>
            </v-flex>
            <v-flex xs4>
            <v-btn
              dark
              v-on:click="openCropEditor()">
              <v-icon>crop</v-icon>
              Crop
            </v-btn>
            </v-flex>
            <v-flex xs3>
              <v-select
                v-if="maxFrame > 1"
                label="speed"
                style="max-width='90px'"
                v-on:change="onClickAnimating()"
                v-model="speed" :items="['slower','slow', 'normal', 'fast']">
              </v-select>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div v-if="apngAnimating">
        <v-divider ></v-divider>
        <v-spacer></v-spacer>
        <div v-if="bIsRemote">
          <div class="white--text">
            By uploading this picture, you certify that you have the rights required to do so.
          </div>
           <v-spacer></v-spacer>
          <v-btn
            style="margin: 15px"
            class="red darken-3"
            v-on:click="useLocalPic()">
              Upload Pic
          </v-btn>
        </div>
        <div v-else>
          <v-btn
            style="margin: 15px"
            class="yellow darken-3"
            v-on:click="useLocalPic()">
              Use Pic Locally
          </v-btn>
          <v-spacer></v-spacer>
          <div class="white--text">
            Using this picture locally will store it in the cache.  Only you will be able to see it.  You can't publish content with local pictures, and cache space is limited.
          </div>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
// import firebase from 'firebase/app'
import 'firebase/storage'

import SuperGif from 'libgif'
import UPNG from 'upng-js'
import APNGLoader from '../../apng'
import ImageCrop from './ImageCrop'
import helper from '../../helper'
export default {
  components: {
    ImageCrop
  },
  props: {
    bIsRemote: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      gifURL: '',
      picSelected: false,
      faceId: null,
      thumbBlob: null,
      apngBlob: null,
      bProcessing: false,
      apngAnimating: false,
      frameStartEnd: [0, 0],
      gifFrames: null,
      reversed: false,
      cropWidth: null,
      cropHeight: null,
      fileResult: null,
      isTalkrFile: false,
      fileFailed: false,
      originalImageDimensions: null,
      speed: 'normal',
      cachedFrameBoundaries: [0, 0],
      gifURLRules: [
        v =>
          v.length === 0 || v.toLowerCase().indexOf('.gif') !== -1 ||
          'Must specify a file with .gif extension',
        v =>
          v.length === 0 || v.toLowerCase().indexOf('http') === 0 || 'Link must start with http'
      ]
    }
  },
  computed: {
    maxFrame () {
      if (this.gifFrames) {
        return this.gifFrames.length - 1
      }
      return 0
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    onCropImage (data) {
      if (data) {
        this.apngAnimating = false
        this.cropWidth = [data.x, data.width]
        this.cropHeight = [data.y, data.height]
        this.convertGIF(this.fileResult)
      }
    },
    onGIFURLChange () {
      if (
        this.gifURL.toLowerCase().indexOf('.gif') !== -1 &&
        this.gifURL.toLowerCase().indexOf('http') === 0
      ) {
        var onSuccess = () => {
          this.fileFailed = false
          helper.downloadExistingFile(this.gifURL, data => {
            this.convertGIF(data)
          })
        }
        var onFailure = () => {
          this.fileFailed = true
        }
        helper.doesFileExist(this.gifURL, onSuccess, onFailure)
      }
    },
    openCropEditor () {
      if (this.cropFrame == null) {
        // First Crop (original image size)
        var width = this.originalImageDimensions[0]
        var height = this.originalImageDimensions[1]
        var apng = UPNG.encode(
          [this.gifFrames[0].data.data.buffer],
          width,
          height
        )
        var fileLoader = new FileReader()
        var that = this
        fileLoader.onload = function () {
          that.cropFrame = this.result
          if (that.$refs['imagecropper']) {
            that.$refs['imagecropper'].setImage(that.cropFrame)
          }
        }
        fileLoader.readAsDataURL(new Blob([apng]))
      } else {
        if (this.$refs['imagecropper']) {
          this.$refs['imagecropper'].setImage(this.cropFrame)
        } else {
          console.error('could not crop')
        }
      }
    },
    getPlayBackSpeed () {
      if (this.isTalkrFile) {
        return 1.0
      }
      // non-talkr GIFS tend to be too fast,
      // so normal is 0.8
      var speed = 0.8
      switch (this.speed) {
        case 'slower':
          speed = 0.4
          break
        case 'slow':
          speed = 0.55
          break
        case 'normal':
          speed = 0.8
          break
        case 'fast':
          speed = 1
          break
        case 'faster':
          speed = 1.4
          break
        default:
          break
      }
      return speed
    },
    onClickAnimating () {
      this.onUpdateFrameBounds()
    },
    onAPNGEncoded (apng) {
      var apngdiv = this.$refs['animatedpng']
      var oldCanvas = apngdiv.apngCanvas
      this.apngBlob = new Blob([apng])

      this.APNGLoader.loadAPNGData(apng, 'local', canvas => {
        if (canvas) {
          if (apngdiv) {
            apngdiv.apngPlayer = canvas.apng_player
            apngdiv.apngCanvas = canvas
            if (oldCanvas) {
              apngdiv.replaceChild(canvas, oldCanvas)
            } else {
              apngdiv.appendChild(canvas)
            }

            apngdiv.addEventListener('click', event => {
              this.onClickAnimating()
            })
            this.onClickAnimating()
            this.apngAnimating = true
            this.bProcessing = false
          }
        }
      }, () => {
        throw new Error('Could not loadAPNGData in onAPNGEncoded')
      })
    },
    convertGIF (fileResult) {
      this.fileResult = fileResult
      var array = new Uint8Array(fileResult)
      var div = this.$refs['supergifparent']
      div.innerHTML = ''
      var img = document.createElement('img')
      img['rel:auto_play'] = 0
      div.appendChild(img)
      if (!img) throw new Error('Cannot find supergif')
      img.innerHTML = ''

      var options = {
        gif: img,
        max_width: 480,
        progressbar_height: 0
      }
      if (this.originalImageDimensions && this.cropWidth && this.cropHeight) {
        options.cropl = this.cropWidth[0]
        options.cropt = this.cropHeight[0]
        options.cropw = this.cropWidth[1]
        options.croph = this.cropHeight[1]
      }
      var rub = new SuperGif(options)
      rub.load_raw(array, () => {
        this.gifFrames = rub.get_scaled_frames()
        this.isTalkrFile = rub.get_is_talkr()

        var width = this.gifFrames[0].data.width
        var height = this.gifFrames[0].data.height
        // Only do this the first time around
        if (this.originalImageDimensions == null) {
          this.frameStartEnd = [0, this.maxFrame]
          this.originalImageDimensions = []
          this.originalImageDimensions[0] = width
          this.originalImageDimensions[1] = height
        }

        var apng = this.createAPNG()
        if (apng) {
          this.onAPNGEncoded(apng)
        }
      })
    },
    onChangeFrames: function () {
      this.onUpdateFrameBounds()
    },
    onStartChangeFrames: function () {
      this.cachedFrameBoundaries = [this.frameStartEnd[0], this.frameStartEnd[1]]
    },
    onDragFrames: function () {
      var apngdiv = this.$refs['animatedpng']
      if (apngdiv && apngdiv.apngPlayer) {
        apngdiv.apngPlayer.stop()
        var displayFrame = this.frameStartEnd[0]
        if (this.cachedFrameBoundaries[0] === this.frameStartEnd[0]) {
          // If the start index isn't changing but the end index is, show the end index
          if (this.cachedFrameBoundaries[1] !== this.frameStartEnd[1]) {
            displayFrame = this.frameStartEnd[1]
          }
        }
        this.cachedFrameBoundaries = [this.frameStartEnd[0], this.frameStartEnd[1]]
        apngdiv.apngPlayer.renderFullFrame(displayFrame)
      }
    },
    getFrameAnimationFromBounds: function () {
      var startFrame = this.frameStartEnd[0]
      var endFrame = this.frameStartEnd[1]
      var i = 0
      var frames = []
      var frameDur = 40
      if (this.reversed) {
        for (i = endFrame; i >= startFrame; i--) {
          frames.push([i, frameDur])
        }
        for (i = startFrame + 1; i < endFrame; i++) {
          frames.push([i, frameDur])
        }
        // Prevent frame 0 showing when animation is done.
        // @todo customize talkr-apng
        frames.push([endFrame, 100000000])
      } else {
        for (i = startFrame; i <= endFrame; i++) {
          frames.push([i, frameDur])
        }
        for (i = endFrame - 1; i > startFrame; i--) {
          frames.push([i, frameDur])
        }
        // Prevent frame 0 showing when animation is done.
        // @todo customize talkr-apng
        frames.push([startFrame, 100000000])
      }
      return frames
    },
    onUpdateFrameBounds: function () {
      var frames = this.getFrameAnimationFromBounds()
      var apngdiv = this.$refs['animatedpng']
      if (apngdiv && apngdiv.apngPlayer) {
        apngdiv.apngPlayer.playbackRate = this.getPlayBackSpeed()
        apngdiv.apngPlayer._anims = []
        apngdiv.apngPlayer.addAnimToPlay(frames)
        apngdiv.apngPlayer.play_anims()
      }
    },
    createThumb: function (onFinished) {
      if (this.gifFrames) {
        var f = this.frameStartEnd[0]
        if (this.reversed) {
          f = this.frameStartEnd[1]
        }
        var width = this.gifFrames[f].data.width
        var height = this.gifFrames[f].data.height
        var thumb = UPNG.encode([this.gifFrames[f].data.data.buffer], width, height)

        this.resizeImageBlob(new Blob([thumb]), 200, 0.5, onFinished)
      } else {
        throw new Error('No gifFrames')
      }
    },
    createAPNG: function () {
      if (this.gifFrames) {
        var bufferFrames = []
        var delay = []
        var width = this.gifFrames[0].data.width
        var height = this.gifFrames[0].data.height
        var startFrame = 0
        var endFrame = this.maxFrame
        if (this.bProcessing) {
          startFrame = this.frameStartEnd[0]
          endFrame = this.frameStartEnd[1]
        }

        var i = 0
        if (this.reversed && this.bProcessing) {
          for (i = endFrame; i >= startFrame; i--) {
            bufferFrames.push(this.gifFrames[i].data.data.buffer)
            delay.push(this.gifFrames[i].delay)
          }
        } else {
          for (i = startFrame; i <= endFrame; i++) {
            bufferFrames.push(this.gifFrames[i].data.data.buffer)
            delay.push(this.gifFrames[i].delay)
          }
        }
        return UPNG.encode(bufferFrames, width, height, null, delay)
      }
      return null
    },
    generatePNGDataFromStillImage: function (src) {
      return new Promise((resolve, reject) => {
        var canvas = document.createElement('canvas')
        var context = null
        var imageObj = new Image()
        canvas.id = 'pngCanvas'
        canvas.style.visibility = 'hidden'
        document.body.appendChild(canvas)
        context = canvas.getContext('2d')
        var that = this
        imageObj.onload = function () {
          that.frameStartEnd = [0, 0]
          that.gifFrames = [{ data: { width: this.width, height: this.height } }]
          that.originalImageDimensions = [this.width, this.height]

          canvas.width = this.width
          canvas.height = this.height
          // Check for empty images
          if (this.width === 0 || this.height === 0) {
            alert('Image is empty')
          } else {
            context.clearRect(0, 0, this.width, this.height)
            context.drawImage(imageObj, 0, 0)
            canvas.toBlob(
              function (pngBlob) {
                canvas.remove()
                resolve(pngBlob)
              },
              'image/png'
            )
          }
        }
        imageObj.onabort = function () {
          canvas.remove()
          reject(new Error('Image load was aborted.'))
        }
        imageObj.onerror = function () {
          canvas.remove()
          reject(new Error('An error occured while loading image.'))
        }
        imageObj.src = src
      })
    },
    resizeImageBlob: function (blob, maxDimension, compressionRatio, onFinished) {
      var fileLoader = new FileReader()
      var canvas = document.createElement('canvas')
      var context = null
      var imageObj = new Image()

      canvas.id = 'hiddenCanvas'
      var width = maxDimension
      var height = maxDimension
      if (this.gifFrames) {
        width = this.gifFrames[0].data.width
        height = this.gifFrames[0].data.height
      }

      if (width > height) {
        canvas.width = maxDimension
        canvas.height = (maxDimension * height) / width
      } else {
        canvas.width = (maxDimension * width) / height
        canvas.height = maxDimension
      }

      canvas.style.visibility = 'hidden'
      canvas.style.position = 'absolute'
      canvas.style.top = '-' + canvas.height + 'px'
      document.body.appendChild(canvas)

      // get the context to use
      context = canvas.getContext('2d')

      fileLoader.onload = function () {
        var data = this.result
        imageObj.src = data
      }

      fileLoader.onabort = function () {
        alert('The upload was aborted.')
      }

      fileLoader.onerror = function () {
        alert('An error occured while reading the file.')
      }
      fileLoader.readAsDataURL(blob)

      var that = this
      imageObj.onload = function () {
        // Check for empty images
        if (this.width === 0 || this.height === 0) {
          alert('Image is empty')
        } else {
          context.clearRect(0, 0, canvas.width, canvas.height)
          context.drawImage(
            imageObj,
            0,
            0,
            this.width,
            this.height,
            0,
            0,
            canvas.width,
            canvas.height
          )

          // dataURItoBlob function available here:
          // http://stackoverflow.com/questions/12168909/blob-from-dataurl
          // add ')' at the end of this function SO dont allow to update it without a 6 character edit
          // blob = dataURItoBlob(canvas.toDataURL(imageEncoding))

          canvas.toBlob(
            function (jpgBlob) {
              that.thumbBlob = jpgBlob
              canvas.remove()
              if (onFinished) {
                onFinished()
              }
            },
            'image/jpeg',
            compressionRatio
          )
        }
      }
      imageObj.onabort = function () {
        alert('Image load was aborted.')
        canvas.remove()
      }

      imageObj.onerror = function () {
        alert('An error occured while loading image.')
        canvas.remove()
      }
    },
    finishedWithPic (pic, thumb) {
      // Face IDs generated here
      var faceId = Math.random().toString(36).substr(2, 8)
      var onFinished = () => {
        this.apngAnimating = false
        this.gifFrames = null
        this.frameStartEnd = [0, 0]
        this.gifFrames = null
        this.cropWidth = null
        this.cropHeight = null
        this.originalImageDimensions = null
        this.thumbBlob = null
        this.apngBlob = null
        this.cachedFrameBoundaries = [0, 0]
        this.fileResult = null
        this.bProcessing = false
        this.$emit('faceId', faceId)
        this.$emit('close')
      }
      this.$emit('newPicBlobs', {apng: pic, thumb: thumb, faceId: faceId, onFinished: onFinished})
    },
    useLocalPic: function (e) {
      this.bProcessing = true
      this.apngAnimating = false

      setTimeout(() => {
        var apng = this.createAPNG()
        if (apng) {
          this.onAPNGEncoded(apng)
          this.createThumb(() => {
            this.finishedWithPic(this.apngBlob, this.thumbBlob)
          })
        } else {
          throw new Error('Could not create APNG')
        }
      }, 10)
    },
    readPicture: function (event) {
      const file = event.target.files[0] // FileList object
      if (!file) {
        return
      }
      this.picSelected = true
      this.currentFile = file

      const reader = new FileReader()
      // Only process gif files.
      if (file.type.match('image.gif')) {
        reader.onload = e => {
          this.convertGIF(e.target.result)
        }
        reader.readAsArrayBuffer(file)
      } else {
        reader.onload = e => {
          this.generatePNGDataFromStillImage(e.target.result)
            .then((pngdata) => {
              this.resizeImageBlob(pngdata, 200, 0.5, () => {
                this.finishedWithPic(pngdata, this.thumbBlob)
              })
            })
        }
        reader.readAsDataURL(file)
      }
    }
  },
  mounted: function () {
    this.APNGLoader = new APNGLoader()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CharacterPicker/Uploader.vue